import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            大家都在看什么
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            热门话题标签，快速发现当下最火的电影类型与主题
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer no-underline ${
                  item.hot
                    ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {item.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
                {item.name}
              </a>
            ))}
          </div>

          <div className="text-center mt-8">
            <p className="text-xs text-foreground-400">
              共 {topicItems.length} 个热门话题 · 点击标签发现更多精彩电影
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}